import { render, staticRenderFns } from "./EditStatus.vue?vue&type=template&id=ba1b3452"
import script from "./EditStatus.vue?vue&type=script&lang=js"
export * from "./EditStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports